import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-detail',
  templateUrl: './main-detail.component.html',
  styleUrls: ['./main-detail.component.scss']
})
export class MainDetailComponent implements OnInit {

  @Input() year: string;

  constructor() { }

  ngOnInit(): void {
  }

}
